<template>
  <div
    class="mb-3.5 overflow-hidden rounded-lg bg-gradient-to-b from-secondary-600 to-secondary-800 shadow-glow-black shadow-secondary-500/30"
  >
    <nav class="m-px flex overflow-hidden rounded-[0.4375rem]">
      <slot />
    </nav>
  </div>
</template>
